import { CategoriesApiRemoteService } from '../../Services/api/categories/categories-service'
import { ICategoryEntity, IListCategoryPayload, IListCategoryResponse } from '../../Services/api/categories/categories.interface'
import { IFormUsecase } from '../../Shared/Protocol/protocol-form-usecase'
import { Result } from '../../Shared/Protocol/protocol-result'


export class ListCategoriesUseCase
implements IFormUsecase<IListCategoryPayload, IListCategoryResponse> {
  constructor (private readonly CategoriesApi: CategoriesApiRemoteService) {}
    

  public async handle (
    data: IListCategoryPayload
  ): Promise<Result<IListCategoryResponse>> {
    // eslint-disable-next-line no-useless-catch
    try {

      const response = await this.CategoriesApi.list(data)

      if (response.isFailure) {
        return response
      }
    
      const list = response.getValue()

      if(!list) return response
    
      return Result.ok(list)
    } catch (error: any) {
      return Result.fail(error)
    }
  }

 
}
